import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { MdOutlineFileDownload, MdReportProblem } from "react-icons/md";
import ButtonElement from "../../Common/ButtonElement";
import DeviceLogs from "./components/DeviceLogs";
import AddInventory from "./components/AddInventory";
import Transfer from "./components/Transfer";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import { DELETE_POP_UP, downloadCsv, isValidObject } from "../../utils";
import StockCardLayout from "./components/StockCardLayout";
import SearchableDropdown from "../../Common/SearchDropdown";
import { downloadInventoryData, getInvetories, getInvetoryCount, getSuppliers } from "../../actions/inventory";
import { appApis, dropdownDefaultList, headerColumn } from "../../constants";
import { useApiRequest } from "../../hooks/useApiRequest";
import AddSuppliers from "./components/AddSupplier";
import ReasonModal from "../components/ReasonModal";
import { FaX } from "react-icons/fa6";
import { SiScrapy } from "react-icons/si";
import { BiTransfer } from "react-icons/bi";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { RiDeleteBin5Line } from "react-icons/ri";

const filterKeys = ["inventoryTypeId", "inventoryStateId", "deviceModelId", "simStatus", "gpsImei", "supplierId"];

const Inventory = () => {
    const [state, setState] = useState({
        loading: false,
        isdownloading: false,
        showLog: false,
        gpsImei: "",
        current: 1,
        addInventory: false,
        showTransfer: false,
        inventoryType: "",
        inventoryTypeId: null,
        inventoryState: "",
        inventoryStateId: null,
        deviceModel: "",
        deviceModelId: null,
        simStatus:"",
        supplier:"",
        supplierId: null,
        inventoryCount: [],
        inventories: [],
        total: 1,
        inventoryList: [],
        inventoryStateList: [],
        transferList: [],
        modelList: [],
        providerList: [],
        suppliers: [],
        wareHouseList: [],
        selectedInv: {},
        discardData: null,
        addSupply: false,
        firstApi: false,
    });
    const { loading, gpsImei, current, firstApi, inventories, total, isdownloading, showLog, inventoryType, inventoryState, deviceModel, selectedInv, addInventory, showTransfer, inventoryCount, addSupply, discardData, simStatus, suppliers, supplier, wareHouseList } = state;
    const dispatch = useDispatch();
    const { request: lostRequest, loading: lostLoading } = useApiRequest();
    const { request: scrapRequest, loading: scrapLoading } = useApiRequest();
    const { request: deleteRequestAction, loading: deleteRequest } = useApiRequest();

    const { filters, companies, installers } = useSelector(({ inventory, companies, installers }) => ({
        filters: inventory.filters,
        companies: companies,
        installers: installers
    }), shallowEqual);

    const onSelectHandler = (key, value) => {
        setState(prev => ({ ...prev, [key]: value?.name ?? "", [`${key}Id`]: value?.id ?? null }));
    }

    const filterDeviceModal = (inventoryTypeId) => {
        let models = filters?.deviceModels ?? [];
        // if(inventoryTypeId){
        //     models = filters?.deviceModels?.filter(item => item.inventoryTypeId == inventoryTypeId) ?? [];
        // }
        setState(prev => ({ ...prev, modelList: models }));
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
    }

    const getInvData = (pageIndex = null) => {
        const payload = {
            pageSize: 200,
            page: pageIndex ?? current
        };
        filterKeys.forEach(key => {
            const stateKey = state[key];
            if (stateKey) payload[key] = stateKey;
        });
        setState(prev => ({ ...prev, loading: true, firstApi: true }))
        getInvetories(payload).then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, inventories: data?.inventories?.inventories ?? [], total: (data?.inventories?.totalPages ?? 1) * payload.pageSize }));
            }
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const getIntCount = () => {
        getInvetoryCount().then(response => {
            if (response?.data?.data) {
                const inventories = response?.data?.data?.inventories ?? [];
                setState(prev => ({ ...prev, inventoryCount: inventories }))
            }
        }).catch(ex => { })
    }

    const downloadData = () => {
        const payload = [];
        filterKeys.forEach(key => {
            const stateKey = state[key];
            if (stateKey) payload.push(`${key}=${stateKey}`);
        });
        const query = payload?.length > 0 ? `?${payload.join("&")}` : '';
        setState(prev => ({ ...prev, isdownloading: true }));
        downloadInventoryData(query).then(response => {
            downloadCsv(response.data ?? "", "inventory");
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, isdownloading: false })))
    }

    const updateStatus = (data) => {
        const itemId = data?.inventoryTypeId == 20 ? data?.gpsImei : data?.inventoryTypeId == 21 ? data?.iccid : data?.gpsImei;
        const selType = filters?.allTransferType?.find((item) => item.name == data.type) || {};
        const payload = {
            transfer_type_id: selType?.id,
            inventory_state_id: selType?.allowed_states?.[0]?.inventory_state_id,
            inventory_type_id: data?.inventoryTypeId,
            recipient_id: null,
            courier_details: null,
            item_ids: [itemId],
            remark: data?.remark ?? ""
        }
        const options = {
            method: "POST",
            url: appApis.inventoryTransfer,
            body: payload,
            onSuccess: () => {
                setState(prev => ({...prev, discardData: null }))
                paginationAction(1);
            }
        }
        if (data?.typeId == 27) lostRequest(options);
        else scrapRequest(options)
    }

    const resetFilters = () => {
        const initState = {}
        filterKeys.forEach(key => {
            const keyName = key.replace("Id", "");
            initState[keyName] = "";
            initState[`${keyName}Id`] = null;
        });
        setState(prev => ({ ...prev, ...initState, inventoryState: "" }))
    }

    const updateData = () => {
        getIntCount();
        getInvData();
    }

    const deleteAction = (inventoryId) => {
        DELETE_POP_UP(() => {
            deleteRequestAction({
                method: 'DELETE',
                url: `${appApis.deleteInventory}/${inventoryId}`,
                onSuccess: () => paginationAction(1)
            });
        })
    }

    useEffect(() => {
        if (isValidObject(filters)) {
            const { inventoryTypes, simProviders, deviceModels, transferTypes, inventoryStates, suppliers, warehouse } = filters;
            setState(prev => ({ ...prev, inventoryList: inventoryTypes, modelList: deviceModels, providerList: simProviders, transferList: transferTypes, inventoryStateList: inventoryStates, suppliers, wareHouseList: warehouse }));
        }
        getIntCount();
    }, [filters]);

    useEffect(() => {
        getInvData()
    }, [current])

    useEffect(() => {
        if(firstApi) getInvData(1);
    }, [inventoryType, inventoryState, deviceModel, gpsImei, simStatus, supplier])

    return <div className="inventory-container">
        <SearchBox placeholder="Search here..." className="mb-3" value={gpsImei} onChange={(e) => setState(prev => ({ ...prev, gpsImei: e.target.value }))} />
        <StockCardLayout inventoryCount={inventoryCount} inventoryType={inventoryType ? {id: state.inventoryTypeId } : null} filterAction={(value) => onSelectHandler("inventoryType", value)} />
        <TableComponent title={"Inventory"} headers={headerColumn.inventories} data={inventories} paginationAction={paginationAction} current={current} tableLoading={loading} total={total} render={(tdData, index) => <tr key={index} onClick={() => setState(prev => ({ ...prev, showLog: true, selectedInv: tdData }))}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.inventoryType ?? "-"}</td>
            <td>{tdData?.gpsImei ?? "-"}</td>
            <td>{tdData?.deviceModel ?? "-"}</td>
            <td>{tdData?.iccid ?? "-"}</td>
            <td>{tdData?.simNumber ?? "-"}</td>
            <td>{tdData?.simNumber2 ?? "-"}</td>
            <td>{tdData?.simStatus ?? "-"}</td>
            <td>{tdData?.inventoryState ?? "-"}</td>
            <td>
                <div className="d-flex justify-content-end ">
                    {!(tdData?.transferId == 28 || tdData?.transferId == 27) ? <>
                    <ButtonElement text={<MdReportProblem size={20}/>} disabled={tdData?.transferId == 27} cssClass="more-radius me-2" onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({...prev, discardData: {...tdData, type: "Lost"}}))
                    }} variant="btn-outline-grey" loading={lostLoading} />
                    <ButtonElement text={<SiScrapy size={20}/>} disabled={tdData?.transferId == 28} cssClass="more-radius me-2" onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({...prev, discardData: {...tdData, type: "Scrap"}}))
                    }} variant="btn-outline-edit" loading={scrapLoading} />
                    </> : null}
                    <ButtonElement text={<BiTransfer size={20} />} cssClass="more-radius" onClick={(e) => {
                        e.stopPropagation();
                        setState(prev => ({ ...prev, showTransfer: true, selectedInv: tdData }));
                    }} variant="btn-outline-blue" loading={false} />
                    {tdData?.inventoryStateId == 10 ? <ButtonElement text={<RiDeleteBin5Line size={20} />} cssClass="more-radius mx-1" onClick={(e) => {
                        e.stopPropagation();
                        deleteAction(tdData?.inventoryId);
                    }} variant="btn-delete-icon" loading={deleteRequest} /> : null}
                </div>
            </td>
        </tr>} FilterComponent={<>
            <div className="w-100 d-flex justify-content-end">
                {(inventoryType || inventoryState || deviceModel || gpsImei || simStatus || supplier) ? <div className="me-1">
                    <ButtonElement text={<FaX size={18} />} cssClass="small-radius me-1 mb-1" onClick={resetFilters} variant="btn-danger" loading={false} />
                </div> : null}
                <div className="me-1">
                    <SearchableDropdown
                        placeholder={"Inventory Type"}
                        value={inventoryType}
                        error={false}
                        options={filters?.inventoryTypes ?? []}
                        onSelect={(value) => onSelectHandler("inventoryType", value)}
                    />
                </div>
                <div className="me-1">
                    <SearchableDropdown
                        placeholder={"Suppliers"}
                        value={supplier}
                        error={false}
                        options={suppliers || []}
                        onSelect={(value) => onSelectHandler("supplier", value)}
                    />
                </div>
                <div className="me-1">
                    <SearchableDropdown
                        placeholder={"Sim Status"}
                        value={simStatus}
                        error={false}
                        options={dropdownDefaultList?.simStatus ?? []}
                        onSelect={(value) => onSelectHandler("simStatus", value)}
                    />
                </div>
                <div className="me-1">
                    <SearchableDropdown
                        placeholder={"State"}
                        value={inventoryState}
                        error={false}
                        options={filters?.inventoryStates ?? []}
                        onSelect={(value) => onSelectHandler("inventoryState", value)}
                    />
                </div>
                <div className="me-1">
                    <SearchableDropdown
                        placeholder={"Model"}
                        value={deviceModel}
                        error={false}
                        options={filters?.deviceModels ?? []}
                        onSelect={(value) => onSelectHandler("deviceModel", value)}
                    />
                </div>
                <ButtonElement loading={isdownloading} text={<MdOutlineFileDownload fontSize={24} />} cssClass="small-radius me-1 mb-1" onClick={downloadData} variant="btn-outline-grey" />

                <ButtonElement text={<AiOutlineShoppingCart size={20} />} cssClass="more-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, addInventory: true }))} variant="btn-success" loading={false} />

            <ButtonElement text={<BiTransfer size={20} />} cssClass="more-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, showTransfer: true }))} variant="btn-blue-no-hover" loading={false} />
            </div>
        </>} />

        {showLog ? <DeviceLogs showLog={showLog} data={selectedInv} hideModal={() => setState(prev => ({ ...prev, showLog: false, selectedInv: {} }))} /> : null}
        {addInventory ? <AddInventory show={addInventory} hideModal={() => setState(prev => ({ ...prev, addInventory: false, modelList: filters.deviceModels, addSupply: false }))} data={state} filterDeviceModal={filterDeviceModal} updateData={updateData}  showSupplier={() => setState(prev => ({ ...prev, addInventory: false, addSupply: true }))} /> : null}
        {showTransfer ? <Transfer show={showTransfer} hideModal={() => setState(prev => ({ ...prev, showTransfer: false, selectedInv: {} }))} refreshData={getInvData} data={state} companies={companies?.companies ?? []} installers={installers?.installers ?? []} wareHouseList={wareHouseList ?? []} suppliers={suppliers} /> : null}
        {addSupply ? <AddSuppliers showLog={addSupply} hideModal={() => setState(prev => ({ ...prev, addSupply: false }))} getSuppliers={() => dispatch(getSuppliers())} /> : null}
        {discardData ? <ReasonModal show={discardData} title={discardData?.type == "Lost" ? "Lost Inventory" : "Scrap Inventory"} hideModal={() => setState(prev => ({ ...prev, discardData: null }))} submitAction={(remark) => updateStatus({ ...discardData, remark })} /> : null}
    </div>
}

export default Inventory;